import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MobileLiveUpdateService {
  readonly status$ = new BehaviorSubject<string>('');

  async initialize(): Promise<void> {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    try {
      await CapacitorUpdater.notifyAppReady();
      this.status$.next('OTA ready');
    } catch (error) {
      console.warn('Mobile live update initialization failed', error);
      this.status$.next('OTA unavailable');
    }
  }
}
